import { DocumentReference, Timestamp } from '@principle-theorem/shared';
import { IAppointment } from '../appointment/appointment';
import { ITreatmentConfiguration } from '../clinical-charting/treatment/treatment-configuration';

export interface IRecallSettings {
  periodInMonths: number;
  treatmentRefs: DocumentReference<ITreatmentConfiguration>[];
  label?: string;
}

export type NextRecallDue =
  | { isSet: true; isExplicit: boolean; dueAt: Timestamp }
  | { isSet: false; isExplicit: boolean; dueAt: undefined };

export interface IPatientRecall {
  isDisabled: boolean;
  periodInMonths: number;
  periodIsExplicit: boolean;
  nextRecallDue: NextRecallDue;
  nextRecallAppointment?: DocumentReference<IAppointment>;
  lastCompletedAt?: Timestamp;
  lastRecallAppointment?: DocumentReference<IAppointment>;
}

export const DEFAULT_RECALL_PERIOD_IN_MONTHS = 12;

export enum RecallTrack {
  Primary = 'primary',
  Secondary = 'secondary',
}

export const RECALL_TRACK_LABELS: Record<RecallTrack, string> = {
  [RecallTrack.Primary]: 'Primary Recall',
  [RecallTrack.Secondary]: 'Secondary Recall',
};
